import { FC, useEffect } from 'react';
import { AdminModeBar } from '@hssoft/design-system-shared-lib';

interface IAdminModeBarContainer {
  companyName?: string;
  companyGUID?: string;
  appVersion?: string;
}

export const AdminModeBarContainer: FC<IAdminModeBarContainer> = ({
  companyName,
  companyGUID,
  appVersion,
}) => {
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--admin-bar-height', '37px');
    return () => {
      root.style.removeProperty('--admin-bar-height');
    };
  }, []);

  return (
    <AdminModeBar companyName={companyName} companyGUID={companyGUID} appVersion={appVersion} />
  );
};
